'use client';
import React from 'react';

import { ColumnContainer, Label, RowContainerGap } from '@components/Common';
import { Text } from '@components/TextGroups';

interface ProfileInfoBlockProps {
  label: string;
  value: string | undefined | null;
  icon: React.ReactNode;
}

/**
 * Profile Info Block component
 */
export const ProfileInfoBlock: React.FC<ProfileInfoBlockProps> = ({ label, value, icon }) => {
  if (!value) {
    return null;
  }

  return (
    <ColumnContainer>
      <Label>{label}</Label>
      <RowContainerGap>
        {icon}
        <Text>{value}</Text>
      </RowContainerGap>
    </ColumnContainer>
  );
};
